import { Box, Text } from 'braid-design-system';

import { FourPointedStarIcon } from 'src/app/v1/views/shared/Icons/FourPointedStarIcon';

interface AIContentGenerateButtonProps {
  buttonText: string;
  buttonStyle: string;
  buttonTextStyle: string;
  handleOnClick: () => void;
}

export const AIContentGenerateButton = ({
  buttonText,
  buttonStyle,
  buttonTextStyle,
  handleOnClick,
}: AIContentGenerateButtonProps) => (
  <Box
    component="button"
    className={buttonStyle}
    type="button"
    cursor="pointer"
    borderRadius="standard"
    display="flex"
    alignItems="center"
    justifyContent="center"
    marginLeft="gutter"
    paddingX="medium"
    data-testid="ai-generation-cta"
    onClick={() => handleOnClick()}
  >
    <FourPointedStarIcon />
    <Text maxLines={1}>
      <Box component="span" className={buttonTextStyle}>
        {buttonText}
      </Box>
    </Text>
  </Box>
);
